import resume from "../assets/pdf/resume.pdf";
import ProfilePhoto from "../assets/png/ProfilePhoto.png";
export const headerData = {
  name: "Priyanka Soni",
  title: "Web Developer",
  desciption:
  " Full-Stack software developer dedicated to improving skills through hands-on learning and development work. ",
  image: ProfilePhoto,
  resumePdf: resume,
};